// Registro de telas: id do menu → função que a desenha na área de conteúdo.
// Telas ainda não construídas ficam de fora e caem no stub da casca.

import type { Store } from "./store.ts";
import { renderTiposPeca } from "./screens/tipos-peca.ts";
import { renderFuncionarios } from "./screens/funcionarios.ts";
import { renderInsumos } from "./screens/insumos.ts";
import { renderUsuarios } from "./screens/usuarios.ts";
import { renderPerfis } from "./screens/perfis.ts";
import { renderClientes } from "./screens/clientes.ts";
import { renderParametros } from "./screens/parametros.ts";
import { renderTabelaPrecos } from "./screens/tabela-precos.ts";
import { renderLancarOS } from "./screens/lancar-os.ts";
import { renderCronograma } from "./screens/cronograma.ts";
import { renderBacklog } from "./screens/backlog.ts";
import { renderFaturamento } from "./screens/faturamento.ts";
import { renderContasPagar, renderContasReceber } from "./screens/contas.ts";
import { renderRetiradas } from "./screens/retiradas.ts";
import { renderAuditoria } from "./screens/auditoria.ts";
import { renderDashboard } from "./screens/dashboard.ts";

/**
 * Desenha a tela no container. Se retornar uma função, ela é a limpeza
 * (desinscrever do store) chamada quando o usuário sai da tela.
 */
export type ScreenRenderer = (
  container: HTMLElement,
  store: Store,
) => void | (() => void);

export const SCREENS: Record<string, ScreenRenderer> = {
  dashboard: renderDashboard,
  "lancar-os": renderLancarOS,
  "cronograma-coleta-devolucao": renderCronograma,
  backlog: renderBacklog,
  faturamento: renderFaturamento,
  "retiradas-pessoais": renderRetiradas,
  "contas-pagar": renderContasPagar,
  "contas-receber": renderContasReceber,
  clientes: renderClientes,
  "tabela-precos": renderTabelaPrecos,
  "tipos-peca": renderTiposPeca,
  funcionarios: renderFuncionarios,
  insumos: renderInsumos,
  usuarios: renderUsuarios,
  perfis: renderPerfis,
  parametros: renderParametros,
  auditoria: renderAuditoria,
};
